import React from 'react';
import Grid from '@material-ui/core/Grid';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Edit from '@material-ui/icons/Edit';
import { formatDateWithFormat } from '../../../utils/date';
import classNames from 'classnames';
import TablePaginationActionsWrapped from '../../../widgets/TablePagination';
import { itSortExist, onSortClick } from '../../../utils/models';
import CollumnLabel from '../../../widgets/CollumnLabel';
import NoteCollumn from '../../../widgets/NoteCollumn';


const styles = (theme) => ({
    container: {
        marginTop: theme.spacing.unit * 2
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unti * 3,
        overflowX: 'auto',
        boxShadow: 'none'

    },
    table: {
        minWidth: 650,
    },
    typography: {
        color: '#28558a',
    },
    bold: {
        fontWeight: 600
    },
    tableCellBody: {
        color: '#28558a'
    },
    editCollumn: {
        width: 50,
        cursor:'pointer'
    },

})
const CustomTableCell = withStyles(() => ({
    head: {
        backgroundColor: '#bfbfbf',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        padding: 'inherit'

    },
    body: {
        color: "#28558a"
    }

}))(TableCell);

const Component = ({ classes, sort, toggleSort, handleAlert, toggleDialog, alerts, rowsPerPage, page, togglePage, toggleRows }) => {


    return (
        <Grid container className={classes.container}>
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <CustomTableCell><CollumnLabel label="Alert ID" /></CustomTableCell>
                            <CustomTableCell >
                                <Grid container alignItems="center" >
                                    <CollumnLabel label="Client" />
                                    <Grid item xs={1}>
                                        <Grid container justify="flex-end">
                                            {itSortExist('client_name', 'desc', sort) ?
                                                < ExpandLess onClick={() => onSortClick('client_name', 'asc', toggleSort)} /> :
                                                <ExpandMore onClick={() => onSortClick('client_name', 'desc', toggleSort)} />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CustomTableCell>
                            <CustomTableCell>
                                <CollumnLabel label="Status" />
                            </CustomTableCell>
                            <CustomTableCell>
                                <Grid container alignItems="center" >
                                    <CollumnLabel label="Open Date" />
                                    <Grid item xs={1}>
                                        <Grid container justify="flex-end">
                                            {itSortExist('createdDate', 'desc', sort) ?
                                                < ExpandLess onClick={() => onSortClick('createdDate', 'asc', toggleSort)} /> :
                                                <ExpandMore onClick={() => onSortClick('createdDate', 'desc', toggleSort)} />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CustomTableCell>
                            <CustomTableCell>
                                <Grid container alignItems="center" >
                                    <CollumnLabel label="Close Date" />
                                    <Grid item xs={1}>
                                        <Grid container justify="flex-end">
                                            {itSortExist('closedDate', 'desc', sort) ?
                                                < ExpandLess onClick={() => onSortClick('closedDate', 'asc', toggleSort)} /> :
                                                <ExpandMore onClick={() => onSortClick('closedDate', 'desc', toggleSort)} />}
                                        </Grid>
                                    </Grid>
                                </Grid></CustomTableCell>
                            <CustomTableCell>
                                <Grid container alignItems="center" >
                                    <CollumnLabel label="Volume/30 days" />
                                    <Grid item xs={1}>
                                        <Grid container justify="flex-end">
                                            {itSortExist('volume', 'desc', sort) ?
                                                < ExpandLess onClick={() => onSortClick('volume', 'asc', toggleSort)} /> :
                                                <ExpandMore onClick={() => onSortClick('volume', 'desc', toggleSort)} />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CustomTableCell>
                            <CustomTableCell >
                                <CollumnLabel label="Note" />
                            </CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {alerts && alerts.content.map(row => (
                            <TableRow key={row.id}>
                                <TableCell className={classes.editCollumn}>
                                    <Edit onClick={() => { handleAlert(row); toggleDialog(true) }} />
                                </TableCell>
                                <CustomTableCell>
                                    {row.id}
                                </CustomTableCell>
                                <CustomTableCell width="20%">
                                    <Typography className={classNames(classes.tableCellBody, classes.bold)} >
                                        {row.clientDTO && row.clientDTO.name}
                                    </Typography>
                                </CustomTableCell>
                                <CustomTableCell>{row.status}</CustomTableCell>
                                <CustomTableCell>{formatDateWithFormat(new Date(row.createdDate), 'dd/MM/yyyy')}</CustomTableCell>
                                <CustomTableCell>{row.closedDate && formatDateWithFormat(new Date(row.closedDate), 'dd/MM/yyyy')}</CustomTableCell>
                                <CustomTableCell>{row.volume}</CustomTableCell>
                                <CustomTableCell width="30%" >
                                    <NoteCollumn note={row.note} />
                                </CustomTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            {alerts && <TablePagination
                                rowsPerPageOptions={[10, 20, 50]}
                                colSpan={10}
                                count={alerts.totalElements}
                                rowsPerPage={rowsPerPage}
                                onChangeRowsPerPage={toggleRows}
                                page={page}
                                props={alerts}
                                onChangePage={togglePage}
                                ActionsComponent={TablePaginationActionsWrapped}

                            />}
                        </TableRow>
                    </TableFooter>
                </Table>
            </Paper>
        </Grid>
    )
}


const enhance = compose(
    withStyles(styles),
);
export default enhance(Component);